// Trusted Types: der Browser laesst dann nur noch Code und HTML ins Dokument, die durch eine
// benannte Regel gegangen sind. Der Tresor braucht genau eine Ausnahme: die Adresse des
// Krypto-Workers. Erlaubt sind deshalb nur Skriptadressen vom eigenen Ursprung. HTML und
// Skripttext aus Zeichenketten werden nie freigegeben (keine createHTML/createScript-Regel).
// Ohne die passende CSP-Zeile (require-trusted-types-for 'script') ist diese Datei wirkungslos.
if (globalThis.trustedTypes?.createPolicy && !globalThis.trustedTypes.defaultPolicy) {
  globalThis.trustedTypes.createPolicy('default', {
    createScriptURL(url) {
      const parsed = new URL(url, globalThis.location.href);
      if (parsed.origin !== globalThis.location.origin) {
        throw new TypeError(`Skriptadresse von fremdem Ursprung abgelehnt: ${parsed.origin}`);
      }
      return parsed.href;
    }
  });
}
